import { InAppAssessmentProvider } from '@/components/assessments/in-app/in-app-assessment-provider.js';
import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for `/my-classes/*` (TanStack file-based layout: this file sits beside `my-classes/`).
 * URLs stay `/my-classes/calendar`, `/upcoming`, `/past`. The provider stays mounted across those tabs
 * so a running assessment is not torn down, without wrapping the rest of the app.
 */
export const Route = createFileRoute('/_layout/my-classes')({
  component: MyClassesLayout,
});

function MyClassesLayout() {
  return (
    <InAppAssessmentProvider>
      <Outlet />
    </InAppAssessmentProvider>
  );
}
